export default "__VITE_ASSET__1f17af53__"